// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.employee-cell-module__employeeRow__joBbX {

    border-bottom-width: 1px;

    transition-property: all;

    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

    transition-duration: 250ms
}

.employee-cell-module__employeeRow__joBbX:hover {

    background-color: var(--color-bg)
}

.employee-cell-module__employeeRow__joBbX:is(.employee-cell-module__dark__QSU64 *) {

    --tw-border-opacity: 1;

    border-color: rgb(75 85 99 / var(--tw-border-opacity, 1))
}

.employee-cell-module__userDelete__nRP76 {

    border-radius: 9999px;

    --tw-bg-opacity: 1;

    background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));

    padding-top: 0.5rem;

    padding-bottom: 0.5rem;

    padding-left: 1.25rem;

    padding-right: 1.25rem;

    font-weight: 600;

    color: var(--color-white);

    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);

    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);

    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.employee-cell-module__userDelete__nRP76:hover {

    --tw-bg-opacity: 1;

    background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1))
}

.employee-cell-module__userDelete__nRP76:focus {

    outline: 2px solid transparent;

    outline-offset: 2px;

    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);

    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);

    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);

    --tw-ring-color: rgb(167 139 250 / var(--tw-ring-opacity, 1));

    --tw-ring-opacity: 0.75
}

.employee-cell-module__checkbox__zrwLX {

    height: 1rem;

    width: 1rem;

    border-radius: 0.25rem;

    --tw-border-opacity: 1;

    border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));

    --tw-bg-opacity: 1;

    background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(37 99 235 / var(--tw-text-opacity, 1))
}

.employee-cell-module__checkbox__zrwLX:focus {

    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);

    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);

    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);

    --tw-ring-opacity: 1;

    --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1))
}

.employee-cell-module__checkbox__zrwLX:is(.employee-cell-module__dark__QSU64 *) {

    --tw-border-opacity: 1;

    border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));

    --tw-bg-opacity: 1;

    background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));

    --tw-ring-offset-color: #1f2937
}

.employee-cell-module__checkbox__zrwLX:focus:is(.employee-cell-module__dark__QSU64 *) {

    --tw-ring-opacity: 1;

    --tw-ring-color: rgb(37 99 235 / var(--tw-ring-opacity, 1))
}

.employee-cell-module__avatarImage__BUsVO {

    margin-right: 0.75rem;

    height: 2rem;

    width: auto;

    border-radius: 9999px
}

.employee-cell-module__roleBadgeOwner__eyrgW {

    display: inline-flex;

    align-items: center;

    border-radius: 0.25rem;

    background-color: rgb(30 64 175 / var(--tw-bg-opacity, 1));

    --tw-bg-opacity: 0.3;

    padding-left: 0.5rem;

    padding-right: 0.5rem;

    padding-top: 0.125rem;

    padding-bottom: 0.125rem;

    font-size: 0.75rem;

    line-height: 1rem;

    font-weight: 500;

    color: var(--color-black)
}

.employee-cell-module__roleBadgeAdmin__noMUR {

    display: inline-flex;

    align-items: center;

    border-radius: 0.25rem;

    background-color: rgb(107 33 168 / var(--tw-bg-opacity, 1));

    --tw-bg-opacity: 0.3;

    padding-left: 0.5rem;

    padding-right: 0.5rem;

    padding-top: 0.125rem;

    padding-bottom: 0.125rem;

    font-size: 0.75rem;

    line-height: 1rem;

    font-weight: 500;

    color: var(--color-black)
}

.employee-cell-module__statusIndicatorActive__e2k7Q {

    margin-right: 0.5rem;

    height: 0.75rem;

    width: 0.75rem;

    border-radius: 9999px;

    --tw-bg-opacity: 1;

    background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1))
}

.employee-cell-module__statusIndicatorRemoved__cZcDA {

    margin-right: 0.5rem;

    height: 0.75rem;

    width: 0.75rem;

    border-radius: 9999px;

    --tw-bg-opacity: 1;

    background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1))
}

.employee-cell-module__emptyColumn__VTtYm {

    white-space: nowrap;

    padding-left: 1rem;

    padding-right: 1rem;

    padding-top: 0.75rem;

    padding-bottom: 0.75rem
}

.employee-cell-module__contentColumn__yp71O {

    white-space: nowrap;

    padding-left: 1rem;

    padding-right: 1rem;

    padding-top: 0.75rem;

    padding-bottom: 0.75rem;

    font-weight: 500;

    color: var(--color-black)
}

.employee-cell-module__inlineFlexContainer__fMG4l {

    display: inline-flex;

    align-items: center;

    border-radius: 0.25rem;

    --tw-bg-opacity: 0.3;

    padding-left: 0.5rem;

    padding-right: 0.5rem;

    padding-top: 0.125rem;

    padding-bottom: 0.125rem;

    font-size: 0.75rem;

    line-height: 1rem;

    font-weight: 500;

    color: var(--color-black)
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/subviews/employees/subviews/employee-cell.module.css"],"names":[],"mappings":";AAEE;;IAAA,wBAA+D;;IAA/D,wBAA+D;;IAA/D,wDAA+D;;IAA/D;AAA+D;;AAA/D;;IAAA;AAA+D;;AAA/D;;IAAA,sBAA+D;;IAA/D;AAA+D;;AAI/D;;IAAA,qBAAsK;;IAAtK,kBAAsK;;IAAtK,0DAAsK;;IAAtK,mBAAsK;;IAAtK,sBAAsK;;IAAtK,qBAAsK;;IAAtK,sBAAsK;;IAAtK,gBAAsK;;IAAtK,yBAAsK;;IAAtK,6EAAsK;;IAAtK,iGAAsK;;IAAtK;AAAsK;;AAAtK;;IAAA,kBAAsK;;IAAtK;AAAsK;;AAAtK;;IAAA,8BAAsK;;IAAtK,mBAAsK;;IAAtK,2GAAsK;;IAAtK,yGAAsK;;IAAtK,4FAAsK;;IAAtK,6DAAsK;;IAAtK;AAAsK;;AAItK;;IAAA,YAA0L;;IAA1L,WAA0L;;IAA1L,sBAA0L;;IAA1L,sBAA0L;;IAA1L,4DAA0L;;IAA1L,kBAA0L;;IAA1L,4DAA0L;;IAA1L,oBAA0L;;IAA1L;AAA0L;;AAA1L;;IAAA,2GAA0L;;IAA1L,yGAA0L;;IAA1L,4FAA0L;;IAA1L,oBAA0L;;IAA1L;AAA0L;;AAA1L;;IAAA,sBAA0L;;IAA1L,yDAA0L;;IAA1L,kBAA0L;;IAA1L,yDAA0L;;IAA1L;AAA0L;;AAA1L;;IAAA,oBAA0L;;IAA1L;AAA0L;;AAI1L;;IAAA,qBAAmC;;IAAnC,YAAmC;;IAAnC,WAAmC;;IAAnC;AAAmC;;AAInC;;IAAA,oBAA4G;;IAA5G,mBAA4G;;IAA5G,sBAA4G;;IAA5G,0DAA4G;;IAA5G,oBAA4G;;IAA5G,oBAA4G;;IAA5G,qBAA4G;;IAA5G,qBAA4G;;IAA5G,wBAA4G;;IAA5G,kBAA4G;;IAA5G,iBAA4G;;IAA5G,gBAA4G;;IAA5G;AAA4G;;AAI5G;;IAAA,oBAA8G;;IAA9G,mBAA8G;;IAA9G,sBAA8G;;IAA9G,2DAA8G;;IAA9G,oBAA8G;;IAA9G,oBAA8G;;IAA9G,qBAA8G;;IAA9G,qBAA8G;;IAA9G,wBAA8G;;IAA9G,kBAA8G;;IAA9G,iBAA8G;;IAA9G,gBAA8G;;IAA9G;AAA8G;;AAI9G;;IAAA,oBAA6C;;IAA7C,eAA6C;;IAA7C,cAA6C;;IAA7C,qBAA6C;;IAA7C,kBAA6C;;IAA7C;AAA6C;;AAI7C;;IAAA,oBAA2C;;IAA3C,eAA2C;;IAA3C,cAA2C;;IAA3C,qBAA2C;;IAA3C,kBAA2C;;IAA3C;AAA2C;;AAI3C;;IAAA,mBAAiC;;IAAjC,kBAAiC;;IAAjC,mBAAiC;;IAAjC,oBAAiC;;IAAjC;AAAiC;;AAIjC;;IAAA,mBAAwD;;IAAxD,kBAAwD;;IAAxD,mBAAwD;;IAAxD,oBAAwD;;IAAxD,uBAAwD;;IAAxD,gBAAwD;;IAAxD;AAAwD;;AAIxD;;IAAA,oBAAgG;;IAAhG,mBAAgG;;IAAhG,sBAAgG;;IAAhG,oBAAgG;;IAAhG,oBAAgG;;IAAhG,qBAAgG;;IAAhG,qBAAgG;;IAAhG,wBAAgG;;IAAhG,kBAAgG;;IAAhG,iBAAgG;;IAAhG,gBAAgG;;IAAhG;AAAgG","sourcesContent":["\n.employeeRow {\n  @apply border-b dark:border-gray-600 transition-all hover:bg-bg;\n}\n\n.userDelete {\n  @apply py-2 px-5 bg-red-600 text-white font-semibold rounded-full shadow-md hover:bg-red-700 focus:outline-none focus:ring focus:ring-violet-400 focus:ring-opacity-75;\n}\n\n.checkbox {\n  @apply w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600;\n}\n\n.avatarImage {\n  @apply h-8 w-auto mr-3 rounded-full;\n}\n\n.roleBadgeOwner {\n  @apply inline-flex items-center bg-opacity-30 bg-blue-800 text-black text-xs font-medium px-2 py-0.5 rounded;\n}\n\n.roleBadgeAdmin {\n  @apply inline-flex items-center bg-opacity-30 bg-purple-800 text-black text-xs font-medium px-2 py-0.5 rounded;\n}\n\n.statusIndicatorActive {\n  @apply h-3 w-3 rounded-full bg-green-500 mr-2;\n}\n\n.statusIndicatorRemoved {\n  @apply h-3 w-3 rounded-full bg-red-500 mr-2;\n}\n\n.emptyColumn{\n  @apply px-4 py-3 whitespace-nowrap\n}\n\n.contentColumn{\n  @apply px-4 py-3 font-medium text-black whitespace-nowrap\n}\n\n.inlineFlexContainer {\n  @apply inline-flex items-center bg-opacity-30 text-black text-xs font-medium px-2 py-0.5 rounded;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"employeeRow": `employee-cell-module__employeeRow__joBbX`,
	"dark": `employee-cell-module__dark__QSU64`,
	"userDelete": `employee-cell-module__userDelete__nRP76`,
	"checkbox": `employee-cell-module__checkbox__zrwLX`,
	"avatarImage": `employee-cell-module__avatarImage__BUsVO`,
	"roleBadgeOwner": `employee-cell-module__roleBadgeOwner__eyrgW`,
	"roleBadgeAdmin": `employee-cell-module__roleBadgeAdmin__noMUR`,
	"statusIndicatorActive": `employee-cell-module__statusIndicatorActive__e2k7Q`,
	"statusIndicatorRemoved": `employee-cell-module__statusIndicatorRemoved__cZcDA`,
	"emptyColumn": `employee-cell-module__emptyColumn__VTtYm`,
	"contentColumn": `employee-cell-module__contentColumn__yp71O`,
	"inlineFlexContainer": `employee-cell-module__inlineFlexContainer__fMG4l`
};
export default ___CSS_LOADER_EXPORT___;
